/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";

type CardHeaderProps = {
  title: string;
};

const CardHeader: React.FunctionComponent<CardHeaderProps> = ({ title, titleProps, children, ...props }) => {
  return (
    <div className="card__header" {...props}>
      <div className="grid align-items-center">
        <div className="tile">
          <h4 className="h" {...titleProps}>
            {title}
          </h4>
        </div>
        {children}
      </div>
    </div>
  );
};

const CardBody: React.FunctionComponent = ({ children, ...props }) => {
  return (
    <div className="card__content" {...props}>
      {children}
    </div>
  );
};

const Card: React.FunctionComponent = ({ children, ...props }) => {
  return (
    <div className="card mb-4" {...props}>
      {children}
    </div>
  );
};

export default Object.assign(Card, {
  Header: CardHeader,
  Body: CardBody
});
